import React, { useState, useEffect } from "react";
import {
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

const SearchForm = ({ onSearch, initialValue = "" }) => {
  const [inputSearch, setInputSearch] = useState(initialValue);

  useEffect(() => {
    setInputSearch(initialValue);
  }, [initialValue]);

  const submitSearch = (e) => {
    e.preventDefault();

    if (!inputSearch.trim()) {
      return;
    }

    // Passa il termine di ricerca al parent
    onSearch(inputSearch.trim());
  };

  const handleInputSearch = (input) => {
    setInputSearch(input.value);
  };

  const handleResetSearch = () => {
    setInputSearch("");
    // Resetta la ricerca nel parent (passa stringa vuota)
    onSearch("");
  };

  return (
    <div style={{ marginTop: "40px", marginBottom: "40px" }}>
      <Grid
        xs={12}
        spacing={4}
        item
        container
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Grid
          item
          xs={12}
          md={5.3}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Cerca per nome operazione, email, firmatario o team"
            value={inputSearch}
            onChange={(e) => handleInputSearch(e.target)}
            InputProps={{
              endAdornment: inputSearch && (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="clear search"
                    onClick={handleResetSearch}
                    className="color-blue-dark"
                    sx={{
                      "&:hover": {
                        backgroundColor: "transparent",
                      },
                    }}
                    edge="end"
                  >
                    <CloseIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "grey",
                  borderWidth: "1px",
                },
                "&:hover fieldset": {
                  borderColor: "#1b2838",
                  borderWidth: "1px",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#1b2838",
                  borderWidth: "1px",
                },
              },
              "& input::placeholder": {
                fontSize: "14px",
              },
            }}
          />

          <IconButton
            aria-label="submit search"
            onClick={submitSearch}
            disableRipple
            sx={{
              marginLeft: "20px",
              padding: "5px",
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <SearchIcon className="color-blue-dark" />
          </IconButton>
        </Grid>
      </Grid>
    </div>
  );
};
export default SearchForm;
